import { ICellRendererParams } from 'ag-grid-community';
import { Button } from 'primereact/button';
import { useDispatch } from 'react-redux';

import { addToast } from '@/app/slices/toast';
import { ToastLife } from '@/components/hoc/toast-container/enums';
import { useCombineShipments } from '@/services/fresh-shipment/hooks';

type FreshShipmentCombineButtonProps = {
  params: ICellRendererParams;
};

export const FreshShipmentCombineButton = ({
  params,
}: FreshShipmentCombineButtonProps) => {
  const { mutateAsync: combineShipments } = useCombineShipments();
  const dispatch = useDispatch();

  const handleCombineShipments = async (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    event?.stopPropagation();
    const selectedRows = params.api.getSelectedRows();
    const selectedShipmentIds = selectedRows?.map(
      (row: any) => row?.freshShipmentId,
    );

    if (selectedShipmentIds.length < 2) {
      dispatch(
        addToast({
          severity: 'warn',
          summary: 'Selection Required',
          detail: 'Please select at least 2 fresh shipments to combine.',
          life: ToastLife.DEFAULT,
        }),
      );
      return;
    }

    const freshShipIdList = selectedShipmentIds?.map((shipmentId: string) => ({
      shipmentId: shipmentId,
    }));
    await combineShipments({
      freshShipIdList,
    });
  };

  return (
    <div className={`fresh-shipment-combine-button__wrapper`}>
      <Button
        onClick={handleCombineShipments}
        className="fresh-shipment-combine-button"
        label="Combine"
        severity="secondary"
      />
    </div>
  );
};
